import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { decorateSchool, schoolsListSortMap } from "./_helpers";
import { applyListParams } from "../_shared";

const SUPERUSER_LIMIT = 5;

export const my_schools: Query<Ctx> = async ({ sb }, params) => {
  const { data: sessionData } = await sb.auth.getSession();
  const userId = sessionData.session?.user?.id;
  if (!userId) return [];

  const { data: profile } = await sb
    .from("profiles_internal")
    .select("role")
    .eq("user_id", userId)
    .single();
  const role = profile?.role;
  if (!role) return [];

  let query = sb.from("v_schools_list").select("*");

  if (role === "superuser") {
    query = query.limit(SUPERUSER_LIMIT);
  } else if (role === "school_admin") {
    const { data: links } = await sb
      .from("school_admins_schools")
      .select("school_id")
      .eq("user_id", userId);
    const schoolIds = (links ?? []).map((l) => l.school_id);
    if (schoolIds.length === 0) return [];
    query = query.in("id", schoolIds);
  } else {
    return [];
  }

  query = applyListParams(query, params, {
    sort: {
      map: schoolsListSortMap,
      default: [{ column: "name" }],
    },
  });

  const { data } = await query;
  if (!data) return [];
  return data.map(decorateSchool);
};
